<template>
  <b-modal
    id="invite-tradie-modal"
    modal-class="timesheet-modal"
    title="Invite Tradie"
    ok-title="Send Invite"
    :ok-disabled="!form.email || form.loading"
    @ok="$emit('ok', $event)"
    @hidden="$emit('hidden')"
  >
    <p class="text-muted" style="font-size: 13px">
      This invites the tradie to your company. A new account will be created and
      a welcome email sent with their login details if they aren't yet in the
      system. Add them to a project separately once they've joined.
    </p>
    <b-form-group label="Email address">
      <b-form-input
        v-model="form.email"
        type="email"
        placeholder="tradie@example.com"
      />
    </b-form-group>
  </b-modal>
</template>

<script>
export default {
  name: 'TimesheetInviteModal',
  props: {
    form: { type: Object, required: true },
  },
}
</script>
